import React, { useState, useEffect } from "react";
import {
  Dropdown,
  Badge,
  Card,
  List,
  Button,
  Spin,
  Typography,
  Empty,
  Space,
} from "antd";
import { useAuthContext } from "../hooks/useAuthContext";
import jwtDecode from "jwt-decode";
import getNotifications from "./notificationsAPI";
import BulkSignals from "./notificationTypes/BulkSignals";
import { useNotifications } from "./NotificationContext";
import "./NewNotifications.css";

const { Title, Text } = Typography;

const NewNotifications = () => {
  const { user } = useAuthContext();
  const userId = user ? jwtDecode(user.token)?._id : null;
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    isNotificationOpen,
    closeNotifications,
    openNotifications,
    shouldRefresh,
    resetRefresh,
  } = useNotifications();

  const unreadCount = notifications.filter(
    (notification) => notification.status !== "read"
  ).length;

  const fetchNotifications = async () => {
    if (user && userId) {
      const data = await getNotifications(user, userId, setLoading);
      setNotifications(data);
    }
  };

  useEffect(() => {
    if (shouldRefresh && user) {
      fetchNotifications();
      resetRefresh();
    }
  }, [shouldRefresh, user, resetRefresh]);

  useEffect(() => {
    if (isNotificationOpen && user) {
      fetchNotifications();
    }
  }, [isNotificationOpen, user]);

  const handleNotificationChange = async () => {
    await fetchNotifications();
  };

  if (!user) return null;

  const notificationContent = (
    <Card
    bodyStyle={{ padding: 0 }}
    className="no-border-card"
    style={{
      width: 380,
      borderRadius: 8,
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      background: "var(--bs-ant-blue) !important",
    }}
  >
      <div style={{ padding: "16px 24px", borderBottom: "1px solid rgba(255, 255, 255, 0.1)", display: "flex", alignItems: "center" }}>
        <i className="fas fa-bell" style={{ marginRight: 8, color: "#1890ff" }} />
        <Title level={5} style={{ margin: 0, color: '#fff' }}>
          Notifications ({unreadCount})
        </Title>
      </div>

      <div style={{ maxHeight: 400, overflowY: "auto" }}>
        {loading ? (
          <div style={{ padding: 32, textAlign: "center" }}>
            <Spin size="large" tip="Loading notifications..." />
          </div>
        ) : notifications.length === 0 ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <Space>
                <i className="fas fa-bell-slash" style={{ color: "white" }} />
                <span style={{color:"white"}}>No notifications available</span>
              </Space>
            }
            style={{ margin: "32px 0" }}
          />
        ) : (
          <List
          dataSource={notifications.filter((notification) => notification.status !== "read")}
          renderItem={(notification) => (
            <List.Item style={{ padding: "12px 24px", borderBottom: "1px solid rgba(255, 255, 255, 0.1)" }}>
              {notification.type === "bulk_signals" ? (
                <BulkSignals
                  bulkSignals={[notification]}
                  onStatusChange={handleNotificationChange}
                />
              ) : (
                <Space direction="vertical" size={4} style={{ width: "100%" }}>
                  <Text strong>{notification.type}</Text>
                  <Text>{notification.message}</Text>
                </Space>
              )}
            </List.Item>
          )}
        />        
        )}
      </div>

      <div style={{ padding: 16, borderTop: "1px solid rgba(255, 255, 255, 0.1)" }}>
        <Button type="primary" block onClick={closeNotifications}>
          Close
        </Button>
      </div>
    </Card>
  );

  return (
    <Dropdown
    overlay={notificationContent}
    trigger={["click"]}
    open={isNotificationOpen}
    onOpenChange={(visible) => {
      visible ? openNotifications() : closeNotifications();
    }}
  >
    <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
      <Badge 
        count={unreadCount}
        offset={[10, -6]} 
        style={{
          backgroundColor: "#ff4d4f",
          color: "#fff",
        }}
      >
        <i
          className="fas fa-bell"
          style={{
            fontSize: "18px",
            color: "var(--bs-theme)",
            transition: "color 0.3s ease",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#40a9ff")} 
          onMouseLeave={(e) => (e.currentTarget.style.color = "var(--bs-theme)")} 
        />
      </Badge>
    </div>
  </Dropdown>
  
  );
};

export default NewNotifications;
